/**
 * 스킵 허용 판정. `docs/05-receiver-sdk.md` 의 정의 그대로다.
 *
 *     canSkip = skip.allowed === true && elapsedSec >= skip.minWatchSec
 *
 * 순수 함수로 두는 이유: 리시버 상태를 만들지 않고 표를 채워 검증할 수 있다.
 * 또한 M6 의 건너뛰기 버튼이 같은 판정을 재구현하지 않게 한다 — 버튼 상태와 실제 동작이
 * 어긋나면 눌리는데 아무 일도 안 일어나는 버튼이 생긴다.
 */
export function canSkip(item, elapsedSec) {
    if (!item)
        return false;
    if (!item.skip.allowed)
        return false;
    return elapsedSec >= item.skip.minWatchSec;
}
/**
 * 스킵까지 남은 초. 버튼 비활성 표시에 쓴다.
 * 스킵이 아예 금지된 항목은 `null` — 버튼을 숨겨야 하는 상태이고, 남은 초를
 * 보여주는 것 자체가 잘못된 신호다.
 */
export function secondsUntilSkippable(item, elapsedSec) {
    if (!item || !item.skip.allowed)
        return null;
    return Math.max(0, Math.ceil(item.skip.minWatchSec - elapsedSec));
}
//# sourceMappingURL=skip-policy.js.map